<template>
    <rkm-area
        title="Etapas clínicas"
        type="fieldset"
    >
        <rkm-form ref="Form">
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="etapasClinicas"
                        :validations="validations.etapaClinica"
                        label="Etapa clínica"
                        show-default-option
                        text-field="nome"
                        v-model="model.etapaClinicaId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click="$refs.Form.validate(add)"
                        color="primary"
                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            hide-filters
            :items="data.model.etapasClinicas"
            :fields="fields"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    :disabled="disableDestroy(item)"
                    @click="handleDestroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </rkm-area>
</template>

<script>
// Mixins.
import { object } from '@/mixins'

// Enums.
import etapaClinica from '@/enums/cadastro/oci/etapaClinica'

export default {
    computed: {
        validations() {

            return {
                etapaClinica: { required: true }
            }
        },
        etapasClinicas() {

            if (!this.data.model.etapasClinicas.find(ec => ec.etapaClinicaId === this.enums.etapaClinica.ENTRADA)) {

                return this.data.form.etapasClinicas.filter(ec => ec.id === this.enums.etapaClinica.ENTRADA)
            }
            else if (!this.data.model.etapasClinicas.find(ec => ec.etapaClinicaId === this.enums.etapaClinica.RETORNO)) {

                return this.data.form.etapasClinicas.filter(ec => ec.id === this.enums.etapaClinica.RETORNO)
            }

            return this.data.form.etapasClinicas.filter(etapaClinica =>
                !this.data.model.etapasClinicas.find(ec => ec.etapaClinicaId === etapaClinica.id))
        },
    },
    data: () => ({
        model: {
            etapaClinicaId: null,
        },
        fields: [
            { key: 'etapaClinicaNome', label: 'Etapa clínica', sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' }
        ],
        enums: { etapaClinica }
    }),
    methods: {
        add() {

            const data = this.clone(this.model)

            data.etapaClinicaNome = this.data.form.etapasClinicas.find(ec => ec.id === data.etapaClinicaId).nome

            this.data.model.etapasClinicas.push(data)

            this.resetForm()
        },
        resetForm() {

            this.model.etapaClinicaId = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        disableDestroy(etapaClinica) {

            if (etapaClinica.etapaClinicaId === this.enums.etapaClinica.ENTRADA) {

                return !!this.data.model.etapasClinicas.find(ec => ec.etapaClinicaId === this.enums.etapaClinica.RETORNO)
            }
            else if (etapaClinica.etapaClinicaId === this.enums.etapaClinica.RETORNO) {

                return !!this.data.model.etapasClinicas.find(ec => [
                    this.enums.etapaClinica.REABILITACAO,
                    this.enums.etapaClinica.TRATAMENTO,
                    this.enums.etapaClinica.ALTA
                ].includes(ec.etapaClinicaId))
            }

            return false
        },
        handleDestroy(etapaClinica) {

            const destroy = async () => {

                this.data.model.etapasClinicas.splice(this.data.model.etapasClinicas.indexOf(etapaClinica), 1)
            }

            this.showDeleteConfirmation('Deseja realmente excluir a etapa clínica?', destroy)
        }
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true }
    }
}
</script>